module.exports = __webpack_public_path__ + "img/success_f.b1479624.gif";